export enum AppStore {
  APPLE_APP_STORE = 'appleAppStore',
  APPLE_APP_STORE_BADGE = 'appleAppStoreBadge',
  GOOGLE_PLAY_STORE = 'googlePlayStore',
  GOOGLE_PLAY_STORE_BADGE = 'googlePlayStoreBadge',
  HUAWEI_APP_GALLERY = 'huaweiAppGallery',
  HUAWEI_APP_GALLERY_BADGE = 'huaweiAppGalleryBadge',
  /** Global numeric App Store app ID for the ratings cron (not per-locale OneLinks). */
  IOS_APP_STORE_ID = 'iosAppStoreId',
  /** Global Google Play package name for the ratings cron. */
  ANDROID_APP_PACKAGE_ID = 'androidAppPackageId',
}

export enum APP_STORE_LINK_TYPE {
  AUTOMATIC = 'automatic',
  SPECIFIC = 'specificStore',
}
